require('./scroll-slider');
require('./swipe-slider');
require('./rslider');